import type { RegistryClient } from './client';
import type { RegistryState } from './types';

export const MOCK_REGISTRY_STATE: RegistryState = {
  floors: [
    { floor_id: 'ground', name: 'Ground Floor', level: 0 },
    { floor_id: 'first', name: 'First Floor', level: 1 },
  ],
  areas: [
    { area_id: 'kitchen', name: 'Kitchen', floor_id: 'ground', icon: 'mdi:silverware-fork-knife' },
    { area_id: 'living_room', name: 'Living Room', floor_id: 'ground', icon: 'mdi:sofa' },
    { area_id: 'bedroom', name: 'Bedroom', floor_id: 'first', icon: 'mdi:bed' },
    { area_id: 'bathroom', name: 'Bathroom', floor_id: 'first', icon: 'mdi:shower' },
  ],
  devices: [
    { device_id: 'dev_kitchen_light', name: 'Kitchen Bulb', area_id: 'kitchen', model: 'Bulb', manufacturer: 'Mock Co' },
    { device_id: 'dev_living_light', name: 'Living Room Bulb', area_id: 'living_room' },
    { device_id: 'dev_living_switch', name: 'Living Room Switch', area_id: 'living_room' },
    { device_id: 'dev_living_media', name: 'Living Room Speaker', area_id: 'living_room', model: 'Sonos One', manufacturer: 'Sonos' },
    { device_id: 'dev_bed_light', name: 'Bedroom Bulb', area_id: 'bedroom' },
    { device_id: 'dev_bed_humid', name: 'Bedroom Humidity Sensor', area_id: 'bedroom' },
    { device_id: 'dev_thermo', name: 'Bedroom Thermostat', area_id: 'bedroom', model: 'T1', manufacturer: 'Mock Co' },
  ],
  entities: [
    {
      entity_id: 'light.kitchen',
      device_id: 'dev_kitchen_light',
      area_id: 'kitchen',
      state: 'on',
      attributes: { friendly_name: 'Kitchen Light', brightness: 200, color_temp: 320 },
      last_changed: '2026-07-11T08:00:00Z',
      labels: ['rsc:pinned'],
    },
    {
      entity_id: 'light.living_room',
      device_id: 'dev_living_light',
      area_id: 'living_room',
      state: 'off',
      attributes: { friendly_name: 'Living Room Light' },
      last_changed: '2026-07-11T07:30:00Z',
      labels: ['rsc:hero'],
    },
    {
      entity_id: 'switch.living_room',
      device_id: 'dev_living_switch',
      area_id: 'living_room',
      state: 'on',
      attributes: { friendly_name: 'Living Room TV Plug' },
      last_changed: '2026-07-11T07:35:00Z',
      labels: [],
    },
    {
      entity_id: 'media_player.living_room',
      device_id: 'dev_living_media',
      area_id: 'living_room',
      state: 'playing',
      attributes: {
        friendly_name: 'Living Room Speaker',
        media_title: 'Midnight City',
        media_artist: 'M83',
        volume_level: 0.42,
      },
      last_changed: '2026-07-11T07:38:00Z',
      labels: [],
    },
    {
      entity_id: 'light.bedroom',
      device_id: 'dev_bed_light',
      area_id: 'bedroom',
      state: 'off',
      attributes: { friendly_name: 'Bedroom Light' },
      last_changed: '2026-07-11T06:00:00Z',
      labels: [],
    },
    {
      entity_id: 'climate.bedroom',
      device_id: 'dev_thermo',
      area_id: 'bedroom',
      state: 'heat',
      attributes: { friendly_name: 'Bedroom Thermostat', current_temperature: 21.5, temperature: 22 },
      last_changed: '2026-07-11T07:45:00Z',
      labels: ['rsc:compact'],
    },
    {
      entity_id: 'sensor.bedroom_humidity',
      device_id: 'dev_bed_humid',
      area_id: 'bedroom',
      state: '48',
      attributes: { friendly_name: 'Bedroom Humidity', unit_of_measurement: '%' },
      last_changed: '2026-07-11T07:50:00Z',
      labels: [],
    },
    {
      entity_id: 'sensor.kitchen_temperature',
      device_id: 'dev_kitchen_light',
      area_id: 'kitchen',
      state: '23.4',
      attributes: { friendly_name: 'Kitchen Temperature', unit_of_measurement: '°C' },
      last_changed: '2026-07-11T08:15:00Z',
      labels: [],
    },
  ],
  labels: ['rsc:hidden', 'rsc:pinned', 'rsc:hero', 'rsc:compact'],
  ready: true,
};

export function createMockRegistryClient(state: RegistryState = MOCK_REGISTRY_STATE): RegistryClient {
  return {
    async loadAll() {
      return state;
    },
    async subscribeUpdates() {
      return () => {};
    },
  };
}
